import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const SampleTypesRoutes: RouteBundle = {
  domain: 'sample-types',
  routes: [{urlPattern: 'sample-types/listing', handler: EditorRoutes.sampleTypesListing.bind(EditorRoutes)}],
};
